module.exports = "/public/images/d081a44ab9536e79e499ce79d1fd78b5.png";